import { LoggedUser, TenantStorage } from '../../session/session-decode';
import { isIntegrator, isSuperUser } from '../../session/user-type';
import { getTenantIdentifier } from './tenant-identifier';
import { ConfigModulos } from './types';

/**
 * Entrada já hidratada (storage decodificado + respostas HTTP) a partir da qual
 * o contexto de menu é derivado. Sem I/O: quem lê storage/HTTP é o efeito
 * (hook), não esta camada.
 */
export interface MenuContextInput {
  user: LoggedUser | null;
  tenant: TenantStorage | null;
  authorities: readonly string[];
  configModulos: ConfigModulos | null;
  ehMulticonta: boolean;
  psimHabilitado: boolean;
  webhookHabilitado: boolean;
  sistemaPSIM: 'SIGMA' | 'SITUATOR_NOVA_API' | string | null;
  lgpdLabel: string | null;
}

/** Contexto do qual `buildMenuTree` deriva `show`/`path`/`tenant` de cada item. */
export interface MenuContext {
  user: LoggedUser | null;
  tenant: TenantStorage | null;
  possuiTenant: boolean;
  identifierTenant: string | undefined;
  authorities: readonly string[];
  isIntegrador: boolean;
  isSuperUsuario: boolean;
  ehMulticonta: boolean;
  configModulos: ConfigModulos | null;
  smsHabilitado: boolean;
  possuiUnidadeAssociada: boolean;
  psimHabilitado: boolean;
  webhookHabilitado: boolean;
  sistemaPSIM: 'SIGMA' | 'SITUATOR_NOVA_API' | string | null;
  lgpdLabel: string | null;
}

/**
 * Deriva o contexto a partir das entradas já hidratadas. Espelha
 * `MenuRoutes.iniciarVariaveisDeValidacoes`, mas sem os efeitos escondidos:
 * quem decodificou storage e resolveu os endpoints é quem chama esta função.
 */
export function buildMenuContext(input: MenuContextInput): MenuContext {
  const { user, tenant } = input;

  return {
    user,
    tenant,
    possuiTenant: tenant !== null,
    identifierTenant: getTenantIdentifier(tenant),
    authorities: input.authorities,
    isIntegrador: isIntegrator(user),
    isSuperUsuario: isSuperUser(user),
    ehMulticonta: input.ehMulticonta,
    configModulos: input.configModulos,
    smsHabilitado: user?.smsHabilitado === true,
    possuiUnidadeAssociada: user?.possuiUnidadeAssociada === true,
    psimHabilitado: input.psimHabilitado,
    webhookHabilitado: input.webhookHabilitado,
    sistemaPSIM: input.sistemaPSIM,
    lgpdLabel: input.lgpdLabel,
  };
}
